import styled from 'styled-components'

export const PriceWithCommercial = styled.div`
  flex: 1;
  margin-top: 20px;

  .card-price {
    display: flex;
    border-radius: 4px;
    align-items: center;
    background-color: var(--color-primary);

    &__symbol {
      width: auto;
      color: #fff;
      line-height: 1;
      padding: 20px;
      font-size: 24px;
      font-weight: 900;
    }

    &__text {
      flex: 1;
      color: #fff;
      padding: 20px 20px 20px 0;
      line-height: 1.1;
    }
  }
`

export const Pipeline = styled.div`
  .pipeline {
    display: flex;
    flex-direction: column;
    max-width: 500px;
    border: 1px solid #D4D4D4;
    border-radius: 6px;
    padding: 40px 20px 20px 20px;

    &__line {
      display: flex;
      overflow: hidden;
      position: relative;
      margin-left: -15px;
      align-items: center;
      padding-bottom: 6px;
      flex-direction: column;
      justify-content: center;
      width: 50px;
      margin-right: 20px;

      &:before, &:after {
        z-index: 1;
        height: 50%;
        content: '';
        width: 7px;
        position: absolute;
        background: #E8E8E8;
      }

      &:before {
        top: 0;
      }

      &:after {
        bottom: 0
      }

      &-indicator {
        z-index: 9;
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;

        > .circle {
          width: 19px;
          height: 19px;
          display: flex;
          position: relative;
          border-radius: 15px;
          align-items: center;
          transition: all 0.3s;
          border: 2px solid #fff;
          justify-content: center;
          background-color: #999999;

          &::after {
            width: 7px;
            content: '';
            height: 7px;
            background: #fff;
            border-radius: 7px;
          }
        }
      }

      &-label {
        display: none;
        font-size: 12px;
        margin-bottom: 4px;
        text-transform: uppercase;
      }
    }

    &__step {
      flex: 1;
      width: 100%;
      display: flex;
      padding-left: 15px;
      padding-right: 15px;

      &--done {
        .pipeline__line {
          &:after {
            background-color: #82D970 !important;
          }
        }

        .pipeline__line-indicator > .circle {
          background: #82D970 !important;
        }
      }

      &--current {
        .pipeline__line {
          &:before {
            background-color: #82D970 !important;
          }
        }

        .pipeline__line-indicator > .circle {
          background: #F4E47D !important;
        }
      }

      &:last-of-type {
        .pipeline__line {
          &:after {
            display: none;
          }
        }
      }

      &:first-of-type {
        .pipeline__line {
          &:before {
            display: none;
          }
        }
      }
    }
  }

  .step {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 50px;
    flex: 1;

    &__name {
      font-size: 18px;
      line-height: 1.1;
      font-weight: bold;
      margin-bottom: 5px;
    }

    &__description {
      font-size: 14px;
      line-height: 1.2;
    }

    &__number {
      font-size: 14px;
      font-weight: 900;
      color: #000;
    }

    &__tag {
      height: 24px;
      color: #606060;
      padding: 0 10px; 
      font-size: 14px;
      line-height: 24px;
      border-radius: 4px;
      background: #D9D9D9;
      margin-bottom: 10px;

      &--done {
        color: #527253;
        background: #EDF7ED;
      }

      &--current {
        color: #685E19;
        background: #FFF7C6;
      }
    }

    &__estimate {
      padding: 10px;
      font-size: 14px;
      line-height: 1.2;
      margin-top: 15px;
      border-radius: 4px;
      border: 1px solid #DDDDDD;

      &-title {
        margin-bottom: 1px;
      }

      &-value {
        font-weight: bold;
      }
    }
  }

  @media screen and (max-width: 1000px) {
    .pipeline {
      flex-direction: column;

      &__line {
        margin-bottom: 5px;

        &:before, &:after {
          display: none;
        }
      }

      &__step {
        margin-bottom: 35px;
      }
    }

    .step {
      align-items: center;
      margin-bottom: 10px;

      &__name, &__description {
        text-align: center;
      }

      &__name {
        margin-bottom: 5px;
      }

      &__estimate {
        &-value, &-title {
          text-align: center;
        }
      }
    }
  }
`

export const Tip = styled.div`
  display: flex;
  margin: 15px 0;
  flex-direction: column;
  align-items: flex-start;

  .title {
    color: #000;
    font-weight: bold;
    margin-bottom: 10px;
    text-transform: uppercase;
  }

  .content-tip {
    font-size: 14px;

    p {
      margin-bottom: 10px;
    }
  }

  .link-tip {
    color: var(--color-primary);
    margin-top: 7px;
    font-weight: bold;
    text-decoration: none;
  }
`

export const Step1Header = styled.header`
  display: flex;
  align-items: center;
  margin-bottom: 50px;

  > div {
    flex: 1;
  }

  .header-content {
    color: #000;
    display: flex;
    padding: 60px 0 20px;
    flex-direction: column;
    justify-content: center;

    p {
      margin-bottom: 10px;

      span {
        font-weight: 700;
      }
    }

    h1 {
      line-height: 1;
      font-size: 44px;
      margin-bottom: 50px;
  
      span {
        font-weight: 900;
      }
    }
  }

  .header-illustration {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  @media screen and (max-width: 1000px) {
    flex-direction: column;

    .header-content {
      h1 {
        font-size: 28px;
      }
    }

    .header-illustration {
      svg {
        height: auto;
        width: 100%;
        margin-top: 20px;
        max-width: 450px;
      }
    }
  }
`

export const Alert = styled.div`
  padding: 15px;
  display: flex;
  color: #527253;
  padding-left: 20px;
  border-radius: 4px;
  align-items: center;
  background: #EDF7ED;
  margin-bottom: 25px;

  .title {
    font-weight: 700;
  }

  .message {
    line-height: 1.2;
  }

  .icon {
    width: 20px;
    margin-right: 20px;

    svg {
      fill: #61B865;
    }
  }

  .info {
    flex: 1;
  }
`

export const Price = styled.div`
  flex: 1;
  margin-bottom: 20px;
  flex-direction: column;

  .price {
    line-height: 1;
    font-size: 42px;
    font-weight: 900;
    color: var(--color-primary);
  }
  
  .per_unit {
    color: #000;
    font-weight: 700;
  }

  &.small {
    margin-bottom: 5px;

    .price {
      font-size: 28px;
    }
  }
`

export const GridProducts = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;
  margin-left: -20px;
  margin-right: -20px;

  .card-product {
    margin: 20px;
    padding: 25px;
    display: flex;
    flex-direction: column;
    width: calc(50% - 40px);

    &--bank-transfer {
      width: 100%;
    }

    &__icon {
      margin-bottom: 20px;

      svg {
        width: 58px;
        height: 58px;
      }
    }

    &__subtitle {
      margin-bottom: 16px;
      margin-top: -9px;
      font-size: 18px;
      line-height: 1.1;
      color: #000;
    }

    &__name {
      color: #000;
      display: flex;
      font-size: 18px;
      line-height: 1.1;
      font-weight: bold;
      align-items: center;
      margin-bottom: 10px;

      > div {
        flex: 1;
        font-weight: bold;
      }

      svg {
        width: 37px;
        height: 37px;
        margin-right: 20px;
      }
    }

    &__description {
      flex: 1;
      color: #7D7D7D;
      line-height: 1.1;
      margin-bottom: 25px;

      p {
        margin-bottom: 10px;

        a {
          font-weight: bold;
          text-decoration: none;
          color: var(--color-primary);
        }

        span {
          font-weight: 700;
        }
      }
    }

    &__features {
      color: #7D7D7D;
      margin-left: 20px;
      margin-top: 20px;
    }
  }

  @media screen and (max-width: 1000px) {
    .card-product {
      margin-top: 0;
      width: calc(100%);

      &__icon {
        margin-bottom: 5px;

        svg {
          width: 38px;
          height: 38px;
        }
      }
    }
  }
`

export const ShowSteps = styled.div`
  width: 100%;
  padding: 20px;
  background: #fff;
  border-radius: 6px;
  margin-bottom: 30px;
  box-shadow: rgb(0 0 0 / 20%) 4px 1px 20px -9px;

  > .title {
    color: #000;
    line-height: 1;
    font-weight: bold;
    margin-bottom: 15px;
  }

  .timeline {
    &__step {
      display: flex;
      overflow: hidden;
      position: relative;
      padding-bottom: 9px;

      &::after {
        top: 0;
        left: 8px;
        width: 3px;
        z-index: 1;
        content: '';
        height: 100%;
        position: absolute;
        background-color: #ECECEC;
      }

      &-indicator {
        z-index: 9;
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;

        > .circle {
          width: 19px;
          height: 19px;
          display: flex;
          position: relative;
          border-radius: 15px;
          align-items: center;
          transition: all 0.3s;
          border: 2px solid #fff;
          justify-content: center;
          background-color: #999999;

          &::after {
            width: 7px;
            content: '';
            height: 7px;
            background: #fff;
            border-radius: 7px;
          }
        }
      }

      &--active {
        padding: 5px 0 30px !important;

        .timeline__step {
          &-indicator {
            > .circle {
              background-color: var(--color-primary);
            }
          }

          &-text {
            &-description {
              opacity: 1 !important;
              max-height: 100px !important;
            }
          }
        }
      }

      &--done {
        cursor: pointer;

        .timeline__step {
          &-indicator {
            > .circle {
              background-color: #82D970;
            }
          }
        }
      }

      &:last-of-type {
        &::after {
          top: auto;
          bottom: 50%;
        }
      }

      &:first-of-type {
        &::after {
          top: 50%;
          bottom: auto;;
        }
      }


      &-text {
        line-height: 1.1;
        padding-left: 13px;

        &-title {
          color: #000;
          font-weight: bold;
        }

        &-description {
          opacity: 0;
          margin-top: 3px;
          font-size: 14px;
          max-height: 0px;
          line-height: 1.2;
          overflow: hidden;
          transition: all 0.3s;
        }
      }
    }
  }
`

export const WizardWrapper = styled.div`
  width: 100%;
  display: flex;
  font-size: 16px;
  min-height: 100vh;
  background: #F5F8FA;

  span {
    font-weight: bold;
  }

  .border-card {
    border-radius: 6px;
    border: 1px solid #D4D4D4;
  }

  button.button-next-wizard {
    border: 0;
    color: #fff;
    height: 55px;
    outline: none;
    font-size: 16px;
    cursor: pointer;
    padding: 0 30px;
    min-width: 150px;
    border-radius: 6px;
    background: var(--color-primary);

    &:disabled {
      cursor: auto;
      background-color: #c7c7c7;

      &:hover {
        opacity: 1;
      }
    }

    &:hover {
      opacity: 0.7;
    }
  }

  .header-page-create-account {
    color: #000;
    font-size: 22px;
    margin-top: 40px;
    max-width: 650px;
    margin-bottom: 55px;

    span {
      font-weight: 900;

      i {
        font-weight: 900;
      }
    }
  }

  @media screen and (max-width: 1000px) {
    flex-direction: column;
  }
`

export const Step3 = styled.div`
  .text-prices {
    width: 100%;
    color: #000;
    max-width: 560px;
    margin-top: 40px;
    margin-bottom: 35px;
  }
`

export const Step4 = styled.div`
  .next-steps {
    width: 100%;
    color: #000;
    max-width: 560px;
    margin-top: 40px;
    margin-bottom: 35px;
  }
`

export const Step2 = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  #formHB {
    width: 100%;
  }

  .need-informations {
    width: 100%;
    color: #000;
    max-width: 560px;
    margin-bottom: 35px;
  }

  .layer-success {
    flex: 1;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;

    &__icon {
      width: 200px;
      height: 200px;
    }

    &__message {
      color: #398c28;
      font-size: 18px;
      font-weight: 700;
      text-align: center;
      margin-top: -50px;
    }
  }

  form {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;

    .input {
      .input-checkbox {
        display: flex;
        margin-bottom: 5px;

        a {
          font-weight: bold;
          text-decoration: none;
          color: var(--color-primary);
        }

        input[type="checkbox"] {
          display: none;
        }

        &__info {
          flex: 1;
          font-size: 16px;
        }

        &__item {
          display: flex;
          cursor: pointer;
          
          &-button {
            width: 18px;
            height: 18px;
            display: block;
            position: relative;
            border-radius: 4px;
            margin-right: 12px;
            background: #E1E1E1;
            
            &:after {
              content: "";
              display: none;
              position: absolute;
            }
          }
        }

        input[type="checkbox"]:checked + .input-checkbox__item-button {
          background: #82D970;

          &:after {
            top: 3px;
            left: 6px;
            width: 4px;
            height: 8px;
            display: block;
            border: solid white;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
          }
        }
      }

      input[type="text"], input[type="email"], select {
        border: 0;
        width: 100%;
        height: 49px;
        padding: 0 20px;
        font-size: 16px;
        border-radius: 4px;
        background: #F5F8FA;
        background-image: none !important;
        outline-color: var(--color-primary);

        &:-webkit-autofill,
        &:-webkit-autofill:hover {
          -webkit-box-shadow: 0 0 0 30px #F5F8FA inset !important;
        }

        &.vol-product {
          width: 100%;
          max-width: 450px;
          margin-top: 6px;
          margin-bottom: 10px;
        }
      }

      .help-text {
        max-height: 0;
        color: #d46b6b;
        font-size: 12px;
        margin-top: 5px;
        overflow: hidden;
        transition: all 0.8s;
      }

      &--error {
        input[type="text"], input[type="email"], select {
          background: #fff;
          outline-style: auto;
          outline-color: #d46b6b;
        }

        .input-checkbox__info {
          color: #d46b6b;
        }

        .help-text {
          max-height: 40px;
        }
      }
    }

    .w50 {
      margin: 10px;
      width: calc(50% - 20px);
    }

    .w100 {
      margin: 10px;
      width: calc(100% - 20px);
    }
  }
`

export const Main = styled.main`
  width: 65%;
  display: flex;
  min-height: 100%;
  overflow: hidden;
  background: #FFF;
  max-width: 1140px;
  padding: 50px 70px;
  flex-direction: column;

  .content-wizard {
    flex: 1;
    display: flex;

    .rsw_2Y {
      flex: 1;
      display: flex;
    }

    .rsw_2f {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }

  @media screen and (max-width: 1000px) {
    width: 100%;
    padding: 25px;
  }
`

export const Aside = styled.aside`
  flex: 1;
  min-height: 100%;
  position: relative;

  > .wrapper {
    width: 100%;
    height: 100vh;
    padding: 50px;
    position: fixed;
    overflow-y: auto;
    background: #F5F8FA;

    > .content-aside {
      width: 100%;
      display: flex;
      max-width: 300px;
      flex-direction: column;
    }
  }

  @media screen and (max-width: 1000px) {
    > .wrapper {
      height: auto;
      padding: 25px;
      position: relative;

      > .content-aside {
        max-width: 100%;
      }
    }
  }
`

export const Footer = styled.footer`
  color: #B4BDC2;
  font-size: 14px;
  line-height: 1.1;
  margin-top: 50px;

  a {
    color: #B4BDC2;
    font-weight: 600;
    text-decoration: none;
  }
`

export const ObsTiming = styled.div`
  max-width: 500px;
  margin-top: 30px;

  h3 {
    font-size: 18px;
    font-weight: bold;
    color: #000;
    margin-bottom: 10px;
  }

  div {
    p {
      margin-bottom: 5px;
    }
  }
`